/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdDropdownItemProps, TdDropdownProps } from './type';

export const dropdownDefaultProps: TdDropdownProps = {
  direction: 'right',
  hideAfterItemClick: true,
  maxColumnWidth: 100,
  maxHeight: 300,
  minColumnWidth: 10,
  placement: 'bottom-left',
  trigger: 'hover',
  popupProps: {},
};

export const dropdownItemDefaultProps: TdDropdownItemProps = {
  active: false,
  disabled: false,
  divider: false,
  theme: 'default',
};
